import React from 'react'
import ContactForm from './ContactForm'
import BackgroundImage from '../../wp-adons/BackgroundImage'
import { setMargin, setPadding } from '../../utilities'

export default function Contact ({
  title,
  slogan,
  background_image,
  margin_selection,
  padding_selection
}) {
  const pageStyles = {
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  return (
    <div
      style={{ ...pageStyles }}
      className='relative w-full z-0 min-h-svh flex items-center justify-center overflow-hidden'
      id='contact'
    >
      <div className='max-w-sitemax w-full relative z-10 flex m-auto text-color_light items-center flex-col lg:flex-row'>
        <div className='flex flex-col justify-start items-start p-8'>
          <p className='font-text_highlight text-header2 mb-4'>{title}</p>
          <ContactForm className='form-wrapper text-color_light font-text_readable w-[90dvw] lg:w-full min-w-[unset] lg:min-w-[450px] flex-1 p-0' />
        </div>
        <p className='text-header2 md:text-header1 text-color_light font-text_highlight md:max-w-xl text-center md:text-left'>
          {slogan}
        </p>
      </div>
      {background_image && (
        <BackgroundImage background_image={background_image} />
      )}
      <span className='bg-black/60 absolute w-full h-full '></span>
    </div>
  )
}
